
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gQ_wvN1AnEC83KeLs86ULagsCUMWlrmKxNQ64fQ3qeYMMeta } from "/codebuild/output/src1100765134/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexfHI5dH2z6i74p0chp6VOCq5MehMXb0BoP9gFATca8lcMeta } from "/codebuild/output/src1100765134/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchNxc0pOskvttH4sl32jG2pMj88BwDLhVx4IVfO9fjD1gMeta } from "/codebuild/output/src1100765134/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexo_45phgkI9W7NR2AWCjPqXvI6j2SUk4Tdq2pgtdREDW7MMeta } from "/codebuild/output/src1100765134/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_9388JTdanEXorHU2X_45DAGG_45RXWlkDsTzkxU6aNOi8_45ZzMMeta } from "/codebuild/output/src1100765134/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexUESWTCsK4f9KgLvfqi6r0g_9WCSSS5zzDCBL70uM2AIMeta } from "/codebuild/output/src1100765134/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93IYjW8bLRoHx5ffRyayOCu_45Q1qNViHABFTlhh4x4L9UUMeta } from "/codebuild/output/src1100765134/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexSJ37inLnOB96Emc8ZLdl1pyzUOo8dybML2uObWTaRroMeta } from "/codebuild/output/src1100765134/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93mA6coH_VD8hOk59MQO0cQfLoW2gvAynq6GAkSqE1xaQMeta } from "/codebuild/output/src1100765134/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexx8ugUtA2I2LcN998NzneQwF6OitLfCTKmu3_FNyph5YMeta } from "/codebuild/output/src1100765134/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexbhSOlFMaXnpkOlXFwn2FBiws2sUhTIJ8fRBmwub92oEMeta } from "/codebuild/output/src1100765134/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src1100765134/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src1100765134/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src1100765134/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src1100765134/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src1100765134/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexUESWTCsK4f9KgLvfqi6r0g_9WCSSS5zzDCBL70uM2AIMeta || {},
    component: () => import("/codebuild/output/src1100765134/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src1100765134/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexSJ37inLnOB96Emc8ZLdl1pyzUOo8dybML2uObWTaRroMeta || {},
    component: () => import("/codebuild/output/src1100765134/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src1100765134/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexx8ugUtA2I2LcN998NzneQwF6OitLfCTKmu3_FNyph5YMeta || {},
    component: () => import("/codebuild/output/src1100765134/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexbhSOlFMaXnpkOlXFwn2FBiws2sUhTIJ8fRBmwub92oEMeta || {},
    component: () => import("/codebuild/output/src1100765134/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]